import { calcDrawableChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

export const getChartModeTypes = ({ answerVariants = [], viewMode }) => {
  if (viewMode === 'totalPickedUp') return ['bpercents']

  const isLarge = answerVariants.length > 12

  if (isLarge) {
    return viewMode === 'amount' ? ['brespondents', 'bpercents'] : ['brespondents']
  }
  return viewMode === 'amount'
    ? ['respondents', 'percents', 'brespondents', 'bpercents']
    : ['respondents', 'brespondents']
}

// the type's own rules; the exported resolver then fits the result to the modes the view offers
const calcPreferredChartMode = ({ chartMode, globalChartMode, modelChartMode, answerVariants = [], viewMode }) => {
  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || modelChartMode || globalChartMode

  // totalPickedUp is always stacked → force bpercents.
  if (viewMode === 'totalPickedUp') return 'bpercents'

  const isLarge = answerVariants.length > 12

  if (isLarge) {
    if (viewMode === 'amount') {
      if (['pie', 'respondents'].includes(mode)) mode = 'brespondents'
      else if (mode === 'percents') mode = 'bpercents'
    } else {
      mode = 'brespondents'
    }
  } else if (viewMode === 'amount') {
    if (mode === 'pie') mode = 'respondents'
  } else {
    if (['pie', 'percents'].includes(mode)) mode = 'respondents'
    if (mode === 'bpercents') mode = 'brespondents'
  }

  return mode
}

export const getDefaultChartMode = args =>
  calcDrawableChartMode(calcPreferredChartMode(args), getChartModeTypes(args), {
    globalChartMode: args.globalChartMode
  })
